<template>
  <div class="gift-content">
    <div class="mobile-guest-section">
      <div class="message-section">
        <img :src="messageReceivedIcon" />
        <div class="message-guest-name">
          Mensagem recebida de <br />{{ data.guest }}
        </div>
        <div class="message-text">
          {{ data.guest_message }}
        </div>
      </div>
      <div class="message-guest-thanks">Agradecer presente por:</div>
      <div class="share-icons">
        <div class="share-icons-link" @click="messageWhatsapp()">
          <img :src="whatsappIcon" style="width: 20px" />
        </div>
        <div class="share-icons-link" @click="messageEmail()">
          <img :src="emailIcon" style="width: 23px" />
        </div>
      </div>
      <div class="check-thanks">
        Marcar como agradecido
        <b-switch
          @input="thankGift"
          class="switch-thanks"
          v-model="grateful"
        ></b-switch>
      </div>
    </div>
  </div>
</template>

<script>
import messageReceivedIcon from '@/assets/img/gift-message.svg'
import whatsappIcon from '@/assets/img/whatsapp.svg'
import emailIcon from '@/assets/img/email.svg'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

import GiftsApi from '@/lib/api/Gifts'

export default {
  props: {
    data: {
      require: true,
    },
  },

  data() {
    return {
      messageReceivedIcon,
      whatsappIcon,
      emailIcon,
      grateful: false,
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },
  },

  mounted() {
    this.grateful = this.data?.grateful
  },

  methods: {
    messageWhatsapp() {
      var message =
        this.data.guest +
        ', adoramos seu presente! %0D%0A %0D%0A Obrigado! %0D%0A %0D%0A ' +
        this.wedSiteInfo.noivo1_nome +
        ' e ' +
        this.wedSiteInfo.noivo2_nome
      window.open('https://web.whatsapp.com/send?text=' + message, '_blank')
    },
    messageEmail() {
      var message =
        'mailto:' +
        this.data.guest_email +
        '?&body=' +
        this.data.guest +
        ', adoramos seu presente! %0D%0A %0D%0A Obrigado! %0D%0A %0D%0A ' +
        this.wedSiteInfo.noivo1_nome +
        ' e ' +
        this.wedSiteInfo.noivo2_nome
      window.open(message, '_blank')
    },
    getUrlImage(image) {
      return `${API_LEGACY_URL}/img/presentes/` + image
    },
    async thankGift() {
      const giftsApi = new GiftsApi(this.logonToken)
      var dataThanks = {
        gift: parseInt(this.data.id),
        status: this.grateful ? 1 : 0,
      }

      giftsApi.thankGift(dataThanks).then((response) => {
        if (response.data.success)
          this.$emit('gratefulChanged', {
            id: this.data.id,
            grateful: this.grateful,
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.gift-content {
  text-align: center;
  margin-top: 24px;
}

bold {
  font-weight: 700;
}

.message-section {
  margin-top: 24px;
  padding: 16px;

  .message-guest-name {
    margin-top: 8px;
    color: $neutraldarkest;
    font-weight: 700;
    font-size: 16px;
  }
  .message-text {
    margin-top: 24px;
    color: $neutral;
    font-weight: 400;
    text-align: justify;
  }
}
.message-guest-thanks {
  margin-top: 24px;
  font-weight: 700;
  font-size: 16px;
  color: $neutraldarkest;
  text-align: left;
  margin-left: 16px;
}

.share-icons {
  margin-top: 24px;
  display: flex;
  gap: 16px;
  margin-left: 16px;
  margin-right: 16px;
}

.share-icons-link {
  border: 1px solid #dde7f1;
  border-radius: 16px;
  height: 56px;
  width: 50%;
  justify-content: center;
  display: flex;
  cursor: pointer;
}

.check-thanks {
  margin-top: 26px;
  margin-bottom: 34px;
  display: flex;
  justify-content: center;
  color: $neutral;

  .switch-thanks {
    margin-left: 8px;
  }
}
</style>
